import gql from 'graphql-tag';

export default gql`
  fragment salesforceContactFieldFragment on SalesforceContactField {
    id
    fieldName
    fieldType
    label
    isDisplay
    updateable
  }
`;
